module.exports = __webpack_public_path__ + "img/bg.847bf026.jpg";